function manageAssetsDialog () {
  return {
    restrict: 'E',
    templateUrl: '/repository/dialogs/manage-assets/manage-assets-dialog.html?$$REVISION$$'
  }
}

export { manageAssetsDialog }
